import React from "react";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import classnames from "classnames";
import { UI_THEME } from "utils/constants/ui";
import { COLORS } from "utils/styles";
import { gridContainer } from "constants/styles";
import ZoneLink from "components/ZoneLink";
import { getIconForUID } from "components/FormerEditor/utils";
import PATHS from "utils/paths";

const FEATURES = {
  API: "api",
  TAX: "tax",
  CUSTOMER: "customer",
  PRE_POST: "pre_post"
};

const DOCS_GRID_CONFIG = [
  {
    id: FEATURES.API,
    label: "REST API",
    description:
      "Our easy to use REST API lets you create payment links from an API call. All the power of Stripe checkout, combined into a single link.",
    action: {
      href: PATHS.DOCS,
      zone: true,
      icon: "rightArrow",
      copy: "Read the docs",
      linkProps: {
        className: "link",
        target: "_blank"
      }
    }
  },
  {
    id: FEATURES.TAX,
    label: "Automatic taxes",
    description:
      "Enable automatic calculation and collection of sales tax, VAT, and GST within checkout, as well as capturing and validating tax ids."
  },
  {
    id: FEATURES.CUSTOMER,
    label: "Customer lookup",
    description:
      "No more duplicate customer creation when using the same email. Simply pass your customer's email as a parameter, and we'll dynamically look them up in your Stripe account."
  },
  {
    id: FEATURES.PRE_POST,
    label: "Pre and post checkout",
    description:
      "Control where your customers get redirected to after checkout by setting the success and cancel url on your payment link.",
    footer: "Additional custom pre-checkout fields coming soon."
  }
];

const FeatureGrid = () => {
  return (
    <div className="w-100">
      <div className="grid-container-2xl pt3">
        {DOCS_GRID_CONFIG.map(
          ({ Icon, label, description, callout, footer, action }, gridIx) => {
            const ActionIcon =
              action && action.icon && getIconForUID(action.icon);
            return (
              <div className="w-100 pb3 pb0-ns" key={gridIx}>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-row items-center w-100">
                    {Icon && <Icon size={20} color={COLORS.primary} />}
                    <div
                      className={classnames(
                        "f4 f3-l fw6 color-text--primary lh-title",
                        {
                          pl2: Icon
                        }
                      )}
                      style={{ marginTop: 2 }}
                    >
                      {label}
                    </div>
                  </div>
                  {callout && <Pill copy={callout} theme={UI_THEME.SLIM} />}
                </div>
                <div className="f5 f4-l lh-copy pt2 mt1 color-text--primary">
                  {description}
                </div>
                {footer && <div className="pt2">{footer}</div>}
                {action && (
                  <div className="pt2">
                    <ZoneLink {...action}>
                      <div className="flex flex-row color-primary pointer">
                        <div className="f5 fw6 link__decoration--hover">
                          {action.copy}
                        </div>
                        {ActionIcon && <ActionIcon size={18} />}
                      </div>
                    </ZoneLink>
                  </div>
                )}
              </div>
            );
          }
        )}
        <style jsx>{gridContainer}</style>
        <style jsx>{cellGrow}</style>
      </div>
    </div>
  );
};

export default FeatureGrid;
